module.exports = __webpack_public_path__ + "static/media/un.0d8a324c.svg";